export default __webpack_public_path__ + "static/media/crates.0298c356.png";